// Ouverture / fermeture des modales Bootstrap 4, avec ou sans jQuery.
// - Si jQuery + Bootstrap JS sont chargés : on les utilise (comportement standard).
// - Sinon : on gère nous-mêmes les classes, le fond gris et les boutons data-dismiss="modal".

const hasBootstrapModal = () =>
    typeof window.$ === "function" && window.$.fn && typeof window.$.fn.modal === "function";

export const showModal = (id) => {
    if (hasBootstrapModal()) {
        window.$(`#${id}`).modal("show");
        return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    el.style.display = "block";
    el.classList.add("show");
    el.setAttribute("aria-modal", "true");
    el.removeAttribute("aria-hidden");
    document.body.classList.add("modal-open");
    if (!document.getElementById(`${id}-backdrop`)) {
        const backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade show";
        backdrop.id = `${id}-backdrop`;
        document.body.appendChild(backdrop);
    }
};

export const hideModal = (id) => {
    if (hasBootstrapModal()) {
        window.$(`#${id}`).modal("hide");
        return;
    }
    const el = document.getElementById(id);
    if (el) {
        el.classList.remove("show");
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
        el.removeAttribute("aria-modal");
    }
    document.getElementById(`${id}-backdrop`)?.remove();
    if (!document.querySelector(".modal.show")) document.body.classList.remove("modal-open");
};

// À appeler une fois par page (dans un useEffect) : sans Bootstrap JS, rend actifs
// les boutons data-dismiss="modal", le clic sur le fond gris et la touche Échap.
export const installModalFallback = () => {
    if (hasBootstrapModal()) return () => {};

    const onClick = (e) => {
        const modal = e.target.closest(".modal");
        if (!modal) return;
        const dismiss = e.target.closest('[data-dismiss="modal"]');
        if (dismiss || e.target === modal) hideModal(modal.id);   // bouton Annuler / × ou clic sur le fond
    };
    const onKey = (e) => {
        if (e.key !== "Escape") return;
        const open = document.querySelectorAll(".modal.show");
        if (open.length) hideModal(open[open.length - 1].id);
    };

    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
        document.removeEventListener("click", onClick);
        document.removeEventListener("keydown", onKey);
    };
};
